import { Button } from 'primereact/button'
import { ITopology, useLazyGetTopologyQuery } from '../../app/apiSlice'
import { setToast } from '../../app/appSlice';
import useHandleExport from '../../hooks/handleExport';
import { useAppDispatch } from '../../hooks/hooks';

const ExportTopology = ({topology}: { topology: ITopology }) => {

    const [getFullTopology] = useLazyGetTopologyQuery();
    const dispatch = useAppDispatch();
    const {handleExport} = useHandleExport();

    return <Button className="p-button-text" icon="pi pi-download"
                   title={'Télécharger'} key={topology.id} onClick={async () => {
        try {
            const data = await getFullTopology({id: topology.id, version: topology.version}).unwrap();
            handleExport(data);
        } catch {
            dispatch(
                setToast({
                    title: `Erreur`,
                    content: `Erreur dans l'export de ${topology.name}`,
                    severity: 'error',
                    life: 6000,
                })
            )
        }
    }}/>
}

export default ExportTopology;